import axios from "axios";

/**
 * ==========================================
 * ENVIRONMENT CONFIG
 * ==========================================
 */

const baseURL =
    window.env?.API_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    "http://68.183.47.27:8080";

const DEBUG_AUTH = process.env.REACT_APP_DEBUG_AUTH === "true";
const DEBUG_API = process.env.REACT_APP_DEBUG_API === "true";

/**
 * ==========================================
 * AXIOS INSTANCE
 * ==========================================
 */

const Api = axios.create({
    baseURL,
    timeout: 10000
});

/**
 * ==========================================
 * REQUEST INTERCEPTOR
 * Pull JWT from sessionStorage.customer
 * ==========================================
 */

Api.interceptors.request.use(
    (config) => {
        try {
            const stored = sessionStorage.getItem("customer");

            if (stored) {
                const customer = JSON.parse(stored);

                if (customer?.token) {
                    config.headers = config.headers || {};
                    config.headers.Authorization = `Bearer ${customer.token}`;

                    if (DEBUG_AUTH) {
                        console.debug("🔐 JWT attached from sessionStorage.customer");
                    }
                } else if (DEBUG_AUTH) {
                    console.warn("⚠️ customer object has no token");
                }
            } else if (DEBUG_AUTH) {
                console.warn("⚠️ No customer in sessionStorage");
            }
        } catch (e) {
            if (DEBUG_AUTH) {
                console.warn("⚠️ Failed to parse customer from sessionStorage", e);
            }
        }

        return config;
    },
    (error) => Promise.reject(error)
);

/**
 * ==========================================
 * RESPONSE INTERCEPTOR
 * ==========================================
 */

Api.interceptors.response.use(
    (response) => {
        if (DEBUG_API) {
            console.debug(
                `✅ [API ${response.status}]`,
                response.config?.method?.toUpperCase(),
                response.config?.url
            );
        }

        if (!response.statusText) {
            response.statusText = "OK";
        }

        return response;
    },

    (error) => {
        const status = error.response?.status;

        if (DEBUG_API) {
            console.warn(
                `❌ [API ERROR${status ? ` ${status}` : ""}]`,
                error.config?.method?.toUpperCase(),
                error.config?.url,
                error
            );
        }

        if (status === 401 || status === 403) {
            if (DEBUG_AUTH) {
                alert(
                    status === 401
                        ? "Your session has expired (401)"
                        : "You are not authorised to perform this action (403)"
                );
            }
        }

        return Promise.reject(error);
    }
);

export default Api;